import { render, staticRenderFns } from "./ManageSection.vue?vue&type=template&id=0ef0c93b&"
import script from "./ManageSection.vue?vue&type=script&lang=js&"
export * from "./ManageSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports